/**
 * Presence Types for Realtime Collaboration
 *
 * Defines types for cursor position, selection, and presence data
 * used in multi-user collaborative editing.
 *
 * @module types/presence
 * @see SPEC-007 Requirements 4.1, 4.2, 4.3, 4.4, 4.5
 */
// Validation constants
export const MAX_DISPLAY_NAME_LENGTH = 50;
export const COLOR_ID_MIN = 0;
export const COLOR_ID_MAX = 7;
/**
 * Validates presence data fields
 * @param data - Partial presence data to validate
 * @returns true if valid, false otherwise
 * @see Requirements 4.4, 4.5
 */
export function validatePresenceData(data) {
    // Validate displayName length
    if (data.displayName !== undefined) {
        if (typeof data.displayName !== 'string')
            return false;
        if (data.displayName.length > MAX_DISPLAY_NAME_LENGTH)
            return false;
    }
    // Validate colorId range
    if (data.colorId !== undefined) {
        if (typeof data.colorId !== 'number')
            return false;
        if (!Number.isInteger(data.colorId))
            return false;
        if (data.colorId < COLOR_ID_MIN || data.colorId > COLOR_ID_MAX)
            return false;
    }
    // Validate cursor position
    if (data.cursor !== null && data.cursor !== undefined) {
        if (!isValidPosition(data.cursor))
            return false;
    }
    // Validate selection
    if (data.selection !== null && data.selection !== undefined) {
        if (!isValidSelection(data.selection))
            return false;
    }
    return true;
}
/**
 * Validates a Position object
 */
function isValidPosition(pos) {
    if (typeof pos !== 'object' || pos === null)
        return false;
    const p = pos;
    return (typeof p.line === 'number' &&
        typeof p.column === 'number' &&
        Number.isInteger(p.line) &&
        Number.isInteger(p.column) &&
        p.line >= 0 &&
        p.column >= 0);
}
/**
 * Validates a Selection object
 */
function isValidSelection(sel) {
    if (typeof sel !== 'object' || sel === null)
        return false;
    const s = sel;
    return isValidPosition(s.anchor) && isValidPosition(s.head);
}
//# sourceMappingURL=presence.js.map